module.exports = __webpack_public_path__ + "static/media/speaker-zhiqiang-mobile.7c156f48.jpg";